// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-placeholder-container[data-v-0fb7f2b0] {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
}
.small-message-placeholder[data-v-0fb7f2b0],
.medium-message-placeholder[data-v-0fb7f2b0],
.large-message-placeholder[data-v-0fb7f2b0] {
  height: 24px;
  border-radius: 12px;
  background: #e3e7ec;
}
.small-message-placeholder[data-v-0fb7f2b0] {
  width: 30%;
}
.medium-message-placeholder[data-v-0fb7f2b0] {
  width: 55%;
}
.large-message-placeholder[data-v-0fb7f2b0] {
  width: 75%;
}
.right[data-v-0fb7f2b0] {
  align-self: flex-end;
  background: #cdd6df;
}`, "",{"version":3,"sources":["webpack://./src/SharedWeb/scripts/dynamic-component-editor/standard-pages/chat-room-page/DynamicChatRoomThread.vue","webpack://./DynamicChatRoomThread.vue"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;ACDF;ADGA;;;EAGE,YAAA;EACA,mBAAA;EACA,mBAAA;ACAF;ADEA;EACE,UAAA;ACCF;ADCA;EACE,UAAA;ACEF;ADAA;EACE,UAAA;ACGF;ADDA;EACE,oBAAA;EACA,mBAAA;ACIF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.message-placeholder-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 12px;\n}\n.small-message-placeholder,\n.medium-message-placeholder,\n.large-message-placeholder {\n  height: 24px;\n  border-radius: 12px;\n  background: #e3e7ec;\n}\n.small-message-placeholder {\n  width: 30%;\n}\n.medium-message-placeholder {\n  width: 55%;\n}\n.large-message-placeholder {\n  width: 75%;\n}\n.right {\n  align-self: flex-end;\n  background: #cdd6df;\n}\n",".message-placeholder-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 12px;\n}\n\n.small-message-placeholder,\n.medium-message-placeholder,\n.large-message-placeholder {\n  height: 24px;\n  border-radius: 12px;\n  background: #e3e7ec;\n}\n\n.small-message-placeholder {\n  width: 30%;\n}\n\n.medium-message-placeholder {\n  width: 55%;\n}\n\n.large-message-placeholder {\n  width: 75%;\n}\n\n.right {\n  align-self: flex-end;\n  background: #cdd6df;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
